import { Controller } from 'stimulus';

export default class extends Controller {
  initialize() {
    $(".media-items-form").hide();
  }
  
  toggleForm(event) {
    var id = $(event.target).data("mediaId");
    $("#edit-mi-" + id).toggle();
  }
}